import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminBoxStatus } from '../../enums/admin-box-status';
import { AdminBoxStatusPipe } from '../../pipes/admin-box-status.pipe';

@Component({
  selector: 'app-admin-box-status',
  imports: [CommonModule, AdminBoxStatusPipe],
  templateUrl: './admin-box-status.component.html',
  styleUrl: './admin-box-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxStatusComponent {
  public readonly status = input.required<AdminBoxStatus>();
}
